export default {
  type: 'layoutColumns',
  shadow: '@theme:card.shadow',
  rounded: '@theme:card.rounded',
  fontName: '@theme:card.fontName',
  bgColor: 'white',
  border: true,
  borderWidth: '1',
  padding: '0',
  fontSize: '3',
  showOriginDestinationImage: false,
  fareItemOriginDestinationImage: {
    heightDestinationImage: 100,
    widthDestinationImage: 100,
    rounded: '@theme:card.rounded',
  },
  separatorJourneyTypeProps: {
    content: '|',
  },
  showJourneyType: true,
  fareItemJourneyType: {},
  showTravelClass: false,
  fareItemTravelClass: {},
  fareItemOriginDestination: {
    showOriginAirportCode: false,
    showDestinationAirportCode: false,
    showSeparator: false,
    showOrigin: false,
    fontWeight: 'bold',
    fontSize: '4',
    textTransform: 'uppercase',
    style: {
      lineHeight: '1',
    },
  },
  showRoute: true,
  fareItemRoute: {
    showOrigin: false,
    textColor: 'black',
    fontWeight: 'bold',
    fontSize: '4',
    marginBottom: '2',
    separatorLabel: {
      content: 'minus',
    },
  },
  showDepartureInfo: true,
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: false,
  fareItemReturnInfo: {
    showReturnText: false,
    showReturnDate: true,
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareBodyItem: {
    textColor: 'dark',
    padding: '2',
    grow: '2',
    marginBottom: '1',
  },
  fareFooterItem: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHeight: '2',
    bgColor: 'primary',
    textColor: 'white',
    grow: '1',
  },
  showPrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    fontWeight: 'bold',
    textAlign: 'center',
    paddingBottom: '1',
    pricePromoStyles: {
      fontWeight: 'bold',
      fontSize: '3',
    },
    currencyStyles: {
      fontSize: '5',
    },
  },
  showLastSeen: true,
  fareItemLastSeen: {
    labelStyles: {
      fontWeight: 'bold',
    },
  },
  showCallToAction: false,
  fareItemCallToAction: {
    shadow: '@theme:button.shadow',
    rounded: '0',
    textTransform: 'uppercase',
    fontSize: '4',
    fontWeight: 'bold',
    showCallToActionTextMin: true,
  },
};
